import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const DisasterRecoveryChecklist = () => {
  const [steps, setSteps] = useState([
    {
      id: 1,
      category: "Analyse und Planung (Analysis and Planning)",
      tasks: [
        {
          id: 101,
          title: "Business Impact Analysis (BIA) durchführen",
          completed: false,
          priority: "hoch",
          deadline: "2025-02-01",
          assignedTo: "IT-Team",
        },
        {
          id: 102,
          title: "Kritische Systeme und Daten priorisieren",
          completed: false,
          priority: "hoch",
          deadline: "2025-02-05",
          assignedTo: "Projektleiter",
        },
        {
          id: 103,
          title:
            "Recovery Time Objective (RTO) und Recovery Point Objective (RPO) festlegen",
          completed: false,
          priority: "mittel",
          deadline: "2025-02-10",
          assignedTo: "Netzwerk-Admin",
        },
        {
          id: 104,
          title: "Disaster-Recovery-Plan (DRP) dokumentieren",
          completed: false,
          priority: "mittel",
          deadline: "2025-02-15",
          assignedTo: "IT-Team",
        },
      ],
    },
    {
      id: 2,
      category: "Vorbereitung (Preparation)",
      tasks: [
        {
          id: 201,
          title: "Regelmäßige Backups einrichten und testen",
          completed: false,
          priority: "hoch",
          deadline: "2025-02-20",
          assignedTo: "Netzwerk-Admin",
        },
        {
          id: 202,
          title: "Redundante Systeme und Datenreplikation implementieren",
          completed: false,
          priority: "hoch",
          deadline: "2025-02-25",
          assignedTo: "IT-Team",
        },
        {
          id: 203,
          title: "Failover-Mechanismen konfigurieren",
          completed: false,
          priority: "mittel",
          deadline: "2025-03-01",
          assignedTo: "Projektleiter",
        },
        {
          id: 204,
          title: "Notfallstandorte oder Cloud-Ressourcen vorbereiten",
          completed: false,
          priority: "niedrig",
          deadline: "2025-03-05",
          assignedTo: "Netzwerk-Admin",
        },
      ],
    },
    {
      id: 3,
      category: "Reaktion und Wiederherstellung (Response and Recovery)",
      tasks: [
        {
          id: 301,
          title: "Notfallteams aktivieren und koordinieren",
          completed: false,
          priority: "hoch",
          deadline: "2025-03-10",
          assignedTo: "IT-Team",
        },
        {
          id: 302,
          title: "Betroffene Systeme isolieren und analysieren",
          completed: false,
          priority: "hoch",
          deadline: "2025-03-15",
          assignedTo: "Netzwerk-Admin",
        },
        {
          id: 303,
          title: "Daten aus Backups wiederherstellen",
          completed: false,
          priority: "hoch",
          deadline: "2025-03-20",
          assignedTo: "Projektleiter",
        },
        {
          id: 304,
          title: "Systeme neu starten und testen",
          completed: false,
          priority: "mittel",
          deadline: "2025-03-25",
          assignedTo: "IT-Team",
        },
        {
          id: 305,
          title: "Kunden und Stakeholder über Fortschritte informieren",
          completed: false,
          priority: "niedrig",
          deadline: "2025-03-30",
          assignedTo: "Projektleiter",
        },
      ],
    },
    {
      id: 4,
      category: "Prüfung und Verbesserung (Testing and Improvement)",
      tasks: [
        {
          id: 401,
          title: "Katastrophensimulationen regelmäßig durchführen",
          completed: false,
          priority: "hoch",
          deadline: "2025-04-05",
          assignedTo: "IT-Team",
        },
        {
          id: 402,
          title: "Erkenntnisse aus Vorfällen dokumentieren",
          completed: false,
          priority: "mittel",
          deadline: "2025-04-10",
          assignedTo: "Projektleiter",
        },
        {
          id: 403,
          title: "Disaster-Recovery-Plan basierend auf Tests aktualisieren",
          completed: false,
          priority: "mittel",
          deadline: "2025-04-15",
          assignedTo: "Netzwerk-Admin",
        },
        {
          id: 404,
          title: "Mitarbeiter in neuen Maßnahmen schulen",
          completed: false,
          priority: "niedrig",
          deadline: "2025-04-20",
          assignedTo: "IT-Team",
        },
      ],
    },
  ]);

  const toggleTaskCompletion = (categoryId, taskId) => {
    setSteps((prevSteps) =>
      prevSteps.map((category) =>
        category.id === categoryId
          ? {
              ...category,
              tasks: category.tasks.map((task) =>
                task.id === taskId
                  ? { ...task, completed: !task.completed }
                  : task
              ),
            }
          : category
      )
    );
  };

  const exportToPDF = () => {
    const element = document.createElement("div");
    steps.forEach((category) => {
      const categoryHeader = document.createElement("h4");
      categoryHeader.textContent = category.category;
      element.appendChild(categoryHeader);

      const taskList = document.createElement("ul");
      category.tasks.forEach((task) => {
        const taskItem = document.createElement("li");
        taskItem.textContent = `${task.title} - Priorität: ${task.priority} - Deadline: ${task.deadline} - Zuständig: ${task.assignedTo}`;
        taskList.appendChild(taskItem);
      });
      element.appendChild(taskList);
    });

    const pdfWindow = window.open("", "_blank");
    pdfWindow.document.write(element.innerHTML);
    pdfWindow.document.close();
    pdfWindow.print();
  };

  return (
    <div className="container m-3">
      {steps.map((category) => (
        <div key={category.id} className="mb-4">
          <h5 className="fw-bold p-3">{category.category}</h5>
          <ul className="list-group">
            {category.tasks.map((task) => (
              <li
                key={task.id}
                className={`list-group-item d-flex justify-content-between align-items-start ${
                  task.completed ? "list-group-item-success" : ""
                }`}
              >
                <div>
                  <span className="fw-bold">{task.title}</span>
                  <div className="mt-1 text-start text-muted">
                    <div>Priorität: {task.priority}</div>
                    <div>Deadline: {task.deadline}</div>
                    <div>Zuständig: {task.assignedTo}</div>
                  </div>
                </div>
                <button
                  className={`btn btn-${
                    task.completed ? "danger" : "success"
                  } btn-sm`}
                  onClick={() => toggleTaskCompletion(category.id, task.id)}
                >
                  {task.completed ? "Rückgängig" : "Erledigt"}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="mt-4 text-center">
        {steps.every((category) =>
          category.tasks.every((task) => task.completed)
        ) && (
          <div className="alert alert-success">
            Alle Schritte und Aufgaben wurden erfolgreich abgeschlossen!
          </div>
        )}
        <button className="btn btn-primary mt-3" onClick={exportToPDF}>
          Exportieren als PDF
        </button>
      </div>
    </div>
  );
};

export default DisasterRecoveryChecklist;
